import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './Icon.module.scss';
import classNames from 'classnames';
export var IconSizes;
(function(IconSizes) {
    IconSizes[IconSizes["XS"] = styles.extraSmallIcon] = "XS";
    IconSizes[IconSizes["SM"] = styles.smallIcon] = "SM";
    IconSizes[IconSizes["MD"] = styles.mediumIcon] = "MD";
    IconSizes[IconSizes["LG"] = styles.largeIcon] = "LG";
})(IconSizes || (IconSizes = {}));
function Icon(param) {
    var _param_size = param.size, size = _param_size === void 0 ? IconSizes.MD : _param_size, icon = param.icon, className = param.className;
    if (icon == null) {
        return null;
    }
    return /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        className: classNames(styles.icon, size, className),
        icon: icon
    });
}
export default Icon;
